import React from "react";

const Updated = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="nonzero">
      <path d="M11.922 23.822C5.358 23.822.037 18.5.037 11.936.037 5.372 5.358.05 11.922.05c6.565 0 11.886 5.322 11.886 11.886-.008 6.561-5.325 11.878-11.886 11.886zm0-22.4c-5.807 0-10.514 4.707-10.514 10.514 0 5.807 4.707 10.514 10.514 10.514 5.807 0 10.515-4.707 10.515-10.514-.007-5.804-4.71-10.508-10.515-10.514z" />
      <path
        d="M17.445 9.13c-.109 0-.217.005-.325.017a4.571 4.571 0 00-8.626-1.355 3.657 3.657 0 10-1.264 7.15v.77a2.832 2.832 0 005.664 0v-.761h4.55a2.912 2.912 0 100-5.822zm-5.285.168l-2.357 2.36a.367.367 0 10.52.518l1.84-1.84v3.886H7.39A2.93 2.93 0 118.549 8.59a.366.366 0 00.482-.201A3.842 3.842 0 0116.427 9.6a.366.366 0 00.458.336c.183-.047.37-.07.56-.07a2.178 2.178 0 110 4.356h-4.551v-3.886l1.828 1.829a.366.366 0 10.528-.508l-2.356-2.359a.576.576 0 00-.35-.183.686.686 0 00-.384.183zm0 6.414a2.1 2.1 0 11-4.199 0v-.761h4.199v.761z"
        stroke="currentColor"
        strokeWidth={0.5}
      />
    </g>
  </svg>
);

export default Updated;
